import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './styles.css';

import logo from '@assets/images/logo-sem-frase.svg';

import { Button } from '@components';
import { useNavigate } from 'react-router-dom';
import { InsereMatricula } from './components/InsereMatricula';
import { InsereToken } from './components/InsereToken';
import { InsereNovaSenha } from './components/InsereSenha';
import { InstrucaoPA } from './components/InstrucaoPA';

export const RecuperarSenhaPage = ({ isPA = false }) => {
  const navigate = useNavigate();
  const estadoProcesso = useSelector((state) => state.recuperacaoSenha);
  const [exibirInstrucao, setExibirInstrucao] = useState(isPA);

  function renderEtapa() {
    if (exibirInstrucao) {
      return <InstrucaoPA setExibirInstrucao={setExibirInstrucao} />;
    }
    if (estadoProcesso.etapa === '2') {
      return <InsereToken />;
    }
    if (estadoProcesso.etapa === '3') {
      return <InsereNovaSenha />;
    }
    return <InsereMatricula />;
  }

  return (
    <div className="container login">
      <div className="row">
        <div className="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-5 mx-auto">
          <div className="card">
            <div className="card-body">
              <img className="logo" src={logo} alt="Logo Forluz" />
              <h1 className="d-block text-center text-muted mb-32 ts-20 fw-bold">
                {isPA
                  ? 'Orientações para cadastro de nova senha'
                  : 'Recuperação de senha'}
              </h1>
              <Button
                className="justify-content-center back"
                transparent
                color="orange"
                icon="arrow_back"
                onClick={() => navigate(-1)}
              >
                Voltar
              </Button>
              {renderEtapa()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
